/**
 * RP 시나리오 AI 서비스 — RP 전용 기능
 *
 * 호출 경로:
 *   Frontend → Java 백엔드 (/api/rp/scenario-ai/*)
 *              → [로컬] FastAPI 직접 포워딩
 *              → [클라우드] AWS AgentCore Runtime (runtime.py handler)
 *
 * ★ 표준 시나리오 플래닝 API (suggest / analyze / getResult / confirm / apply / chat / getLatestVersion)는
 *   scenarioService.js (/api/v1/scenario/rp/*) 를 사용하세요.
 *   이 파일은 RP 전용 기능 (공급 네트워크, 정책 최적화)만 담당합니다.
 */
import { restApiRP } from "@plannel/services/utils/rest-api";
import { getAgentLanguage } from "@plannel/utils/i18n";

const BASE = "/api/rp/scenario-ai";

/** 공급 네트워크 구조 조회 (z_bod + z_location — AI 없이 즉시 반환) */
const getNetwork = () => {
  return restApiRP.get(`${BASE}/network`);
};

/** 보충계획 정책 현황 대시보드 집계 (z_rp_policy 기반) */
const getPolicyState = (params) => {
  return restApiRP.get(`${BASE}/policy-state`, { params });
};

/** 리스크 유형별 상세 품목 조회 (safety_stockout | excess_inv | rop_mismatch | low_freq_no_cycle) */
const getPolicyRiskDetail = (params) => {
  return restApiRP.get(`${BASE}/policy-risk-detail`, { params });
};

/** 보충계획 정책 파라미터 AI 최적화 실행 */
const startPolicyOptimize = (payload) => {
  // LLM 응답을 현재 선택 언어로 — Java 컨트롤러가 body 전체를 FastAPI로 pass-through.
  const body = { language: getAgentLanguage(), ...payload };
  return restApiRP.post(`${BASE}/policy-optimize`, body);
};

const rpScenarioAiService = {
  getNetwork,
  getPolicyState,
  getPolicyRiskDetail,
  startPolicyOptimize,
};
export default rpScenarioAiService;
